import Parse from "parse";

import type { Question } from "./Question";

export interface AnswerAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  acoustics?: number | undefined;
  breathing?: number | undefined;
  correct?: boolean | undefined;
  correctAnswer?: boolean | undefined;
  emotionality?: number | undefined;
  overallImpression?: number | undefined;
  pausesFlow?: number | undefined;
  pronunciation?: number | undefined;
  question?: Question | undefined;
  speechMelody?: number | undefined;
  voiceTone?: number | undefined;
}

export class Answer extends Parse.Object<AnswerAttributes> {
  static className: string = "Antiscam_Answer";

  constructor(data?: Partial<AnswerAttributes>) {
    super("Antiscam_Answer", data as AnswerAttributes);
  }

  get acoustics(): number | undefined {
    return super.get("acoustics");
  }
  set acoustics(value: number | undefined) {
    super.set("acoustics", value);
  }

  get breathing(): number | undefined {
    return super.get("breathing");
  }
  set breathing(value: number | undefined) {
    super.set("breathing", value);
  }

  get correct(): boolean | undefined {
    return super.get("correct");
  }
  set correct(value: boolean | undefined) {
    super.set("correct", value);
  }

  get correctAnswer(): boolean | undefined {
    return super.get("correctAnswer");
  }
  set correctAnswer(value: boolean | undefined) {
    super.set("correctAnswer", value);
  }

  get emotionality(): number | undefined {
    return super.get("emotionality");
  }
  set emotionality(value: number | undefined) {
    super.set("emotionality", value);
  }

  get overallImpression(): number | undefined {
    return super.get("overallImpression");
  }
  set overallImpression(value: number | undefined) {
    super.set("overallImpression", value);
  }

  get pausesFlow(): number | undefined {
    return super.get("pausesFlow");
  }
  set pausesFlow(value: number | undefined) {
    super.set("pausesFlow", value);
  }

  get pronunciation(): number | undefined {
    return super.get("pronunciation");
  }
  set pronunciation(value: number | undefined) {
    super.set("pronunciation", value);
  }

  get question(): Question | undefined {
    return super.get("question");
  }
  set question(value: Question | undefined) {
    super.set("question", value);
  }

  get speechMelody(): number | undefined {
    return super.get("speechMelody");
  }
  set speechMelody(value: number | undefined) {
    super.set("speechMelody", value);
  }

  get voiceTone(): number | undefined {
    return super.get("voiceTone");
  }
  set voiceTone(value: number | undefined) {
    super.set("voiceTone", value);
  }
}

Parse.Object.registerSubclass("Antiscam_Answer", Answer);
